<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    position?: 'top' | 'bottom';
  }>(),
  {
    position: 'top',
  },
);

const contentRef = ref<HTMLDivElement | null>(null);
const firstOpen = ref<boolean>(false);

const positioningContent = function setDropdownContentIntoView() {
  firstOpen.value = true;

  nextTick(() => {
    if (!contentRef.value) return;

    const windowWidth = window.innerWidth;
    const rect = contentRef.value.getBoundingClientRect();

    if (rect.right <= windowWidth) return;

    const dX = windowWidth - rect.right;

    contentRef.value.style.transform = `translateX(${dX}px)`;
  });
};
</script>

<template>
  <div
    class="hover-dropdown"
    :class="`hover-dropdown--${props.position}`"
  >
    <div
      class="hover-dropdown__btn"
      @mouseenter="positioningContent"
      @touchstart="positioningContent"
      @click.prevent.stop
    >
      <slot name="trigger"></slot>

      <svg
        class="hover-dropdown__icon"
        width="16"
        height="16"
      >
        <use
          xlink:href="@/assets/images/svg/sprite-base.svg#chevron-down-16"
        ></use>
      </svg>
    </div>

    <div class="hover-dropdown__wrap">
      <div
        ref="contentRef"
        class="hover-dropdown__inner"
      >
        <slot :first-open="firstOpen"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.hover-dropdown {
  $this: 'hover-dropdown';

  position: relative;

  &:hover {
    .#{$this}__icon {
      transform: rotate(180deg);
    }

    .#{$this}__wrap {
      transform: translateY(0);
      opacity: 1;
      pointer-events: all;
    }
  }

  &__btn {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    column-gap: 5px;
  }

  &__icon {
    color: $color-black-600;
    transition: transform $anim-primary;
  }

  &__wrap {
    padding-top: 16px;
    position: absolute;
    z-index: 1;
    left: 0;
    transition:
      transform $anim-primary,
      opacity $anim-primary;
    opacity: 0;
    pointer-events: none;
  }

  &__inner {
    box-shadow: $shadow-medium-alt;
    border-radius: $brd-12;
    background-color: $color-white;
  }

  &--top {
    .#{$this}__wrap {
      top: 100%;
      transform: translateY(-20px);
    }
  }

  &--bottom {
    .#{$this}__wrap {
      bottom: 100%;
      transform: translateY(20px);
    }
  }
}
</style>
